const config = {
    API_BASE_URL: "https://scrtny12-api.jacexamonline.com",
    //  API_BASE_URL: "https://jacscrutiny12.cludocloud.com/Auth",
    //  API_BASE_URL: "https://localhost:7197",
    MESSAGE_TYPE :"0100",
    CURRENCY : "INR",
    PAYMENT_OPTION:"TRUE",
    PAYMENT_LINK_DEV : "https://pilot.surepay.ndml.in/SurePayPayment/sp/processRequest",
    PAYMENT_RETURN_DEV_LINK:"https://pilot.surepay.ndml.in/SurePayPayment/v1/queryPaymentStatus",
    MERCHANT_ID_DEV : "UATJHACSG0000001627",
    SECRET_KEY_DEV : "f4806d9c32227c81dca87e345443f59e8e989bf57200d9f1801f4f9ff80dc3be",
    SERVICE_ID_DEV : "JHBOARDINTER",
    PAYMENT_RESPONSE_URL_DEV : "https://jacscrutiny12.cludocloud.com/Auth/payment_response",

    PAYMENT_LINK_PRODUCTION : "https://surepay.ndml.in/SurePayPayment/sp/processRequest",
    PAYMENT_RETURN_PRODUCTION:"https://surepay.ndml.in/SurePayPayment/v1/queryPaymentStatus",
    MERCHANT_ID_PRODUCTION : "JHACSG0000000370",
    SECRET_KEY_PRODUCTION : "68ec652c611dd1d03fb74e388b7831149736bb1711b5b1320bd9b7b68ff9c539",
    SERVICE_ID_PRODUCTION  : "JHBOARDINTER",
    TRANSACTION_AMOUNT_PRODUCTION : "1.33",
    PAYMENT_RESPONSE_URL_PRODUCTION : "https://scrtny12-api.jacexamonline.com/payment_response",
  };
  
  
  export default config;